























































/* eslint-disable no-unused-vars */
import BaseForm from '@/views/BaseForm';
import { Component } from 'vue-property-decorator';
import DeleteConfirm from '@/components/DeleteConfirm.vue';
import { AxiosResponse } from 'axios';
import { userMdl } from '@/models/userMdl';
/* eslint-enable no-unused-vars */

@Component({
    name: 'user_list',
    components: { DeleteConfirm },
    head: {
        title: {
            inner: 'ユーザ一覧',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class user_list extends BaseForm {
    // ヘッダー情報
    private userDataHeader: any = [
        { text: 'ユーザアカウント', align: 'center', value: 'user_account' },
        // { text: '会社名', align: 'center', value: 'corp_name' },
        { text: 'ユーザ名', align: 'center', value: 'user_name' },
        { text: 'メールアドレス', align: 'center', value: 'mail_address' },
        { text: '権限', align: 'center', value: 'authority' },
        { text: '編集・削除', align: 'center', value: 'actions', sortable: false },
    ];
    private userDataList: userMdl[] = []; // ユーザデータ一覧
    private itemsPerPage: number = 10; // 1ページに表示するアイテム数
    private deleteConfirmFlg: boolean = false; // 削除確認ダイアログ
    private deleteUserId: number = 0; // 削除するユーザID

    created() {
        if (this.authority > 2) {
            this.userDataHeader.unshift({ text: '会社名', align: 'center', value: 'corp_name', width: 250 });
        }
        this.getUserList();
    }

    // ユーザ一覧の取得
    private async getUserList() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            const resp: AxiosResponse<any> = await this.$http.post('user_data.php', '', {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.userDataList = resp.data.items.map(function(v: any) {
                        return new userMdl(userMdl.toJsonDataOnModel(v));
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // 削除確認ダイアログクローズ
    private closeDeleteDialog(value: boolean) {
        this.deleteConfirmFlg = false;
        if (value) {
            this.userDelete(this.deleteUserId);
        }
    }

    // ユーザ作成・編集
    private onClickEdit(item: userMdl) {
        if (item) {
            this.$router.push({ path: '/user_edit', query: { user_id: String(item.user_id) } });
        } else {
            this.$router.push({ path: '/user_edit' }, () => {});
        }
    }

    // ユーザ削除
    private onClickDelete(item: userMdl) {
        this.deleteConfirmFlg = true;
        this.deleteUserId = item.user_id;
    }
    private async userDelete(user_id: number) {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { user_id: user_id };
            const resp: AxiosResponse<any> = await this.$http.post('user_delete.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    // データの再取得
                    await this.getUserList();
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'データ削除完了',
                        return_flg: false,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ削除失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ削除失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
